import { useEffect } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";

import {
  AiOutlineArrowRight,
} from "react-icons/ai";

import { Link } from "react-router-dom";

const Stories = () => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/BackgroundBrundcrumb.png";
  const storie1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/11.png";
  const storie2 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/12.png";
  const storie21 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/q3twge.jpg";
  const storie5 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/14.png";
  const storie11 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-TENDER-BRANCH-FITOUT-PRESS-AD-25X4-RVS-V2.png";
  const arrowwreport = "https://izbassetsmain.blob.core.windows.net/izbwebassets/report.png";
  const arroww1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/2023-annual report.pdf";
  const arrowwreport2 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Blog_Image.png";
  const arrowwreport3 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Thumbnail_Image.png";
  const arrowwreport4 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/payment-card.png";
  const aarating = "https://izbassetsmain.blob.core.windows.net/izbwebassets/AA-Credit.png";
  const solar = "https://izbassetsmain.blob.core.windows.net/izbwebassets/solar-hybrid.png";
  const rfp = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RFP_Thumbnail.png";
  const addendum = "https://izbassetsmain.blob.core.windows.net/izbwebassets/addendum-Thumbnail_2.png";
  const arroww = "https://izbassetsmain.blob.core.windows.net/izbwebassets/chevron_right.svg";
  const job = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Thumb_Image.png";
  const solarTender = "https://izbassetsmain.blob.core.windows.net/izbwebassets/27-11-Solar_Tender.png";
  const izb2025 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Thumbnail-IZB-2025k.png";
  const career = "https://izbassetsmain.blob.core.windows.net/izbwebassets/EMPLOYMENT AND CAREER DEVELOPMENT OPPORTUNITIES-Thumbnail.png";
  const customerNotice = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Thumbnail-Customer Notice.png";
  const customerNotice1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Customer_Notice_1-thumbnail.png";
  const customerNotice5 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Thumbnail_Notes.png";

  const customerNotice6 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/0519_%20izb-property-Letter-cover.png";

  const customerNotice3 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-invites-bids-for-the-sale-of-the-following-cover-vehicles.png";
  const customerNotice4 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-to-tender-for-the-furbishment-and-fitout-works-of-proposed-izb-branches-cover-banner.png";

  const customerNotice7 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Unwarranted-Charges-And-Fees-Banner.png";
  const customerNotice8 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/CUSTOMER-ENTITLEMENTS-AND-RESPONSIBILITIES-Banner.png";

  const customerNotice9 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_dormat_acount_reactivation_campaign.png"

  const customerNotice10 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_forex_table_revision_thumbnaill.png";

  const customerNotice11 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-clinches-hat-trick-of-provincial-exhibition-awards-thumbnail.png";

  const customerNotice12 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-clinches-another-hat-trick-of-top-honours-thumbnail.png";

  const customerNotice13 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-at-top-of-the-game-in-chingola-thumbnail.png";

  const customerNotice14 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Savings_Products_2024_banner.png";

  const customerNotice15 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-for-proposals-for-consulting-services-job-evaluation-of-the-izb-thumb.png";

  const customerNotice16 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-for-bids-fitout-works-of-proposed-mazabuka-branch-thumb.png"

  const customerNotice17 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/1106_ property_Letter_v1_Artboard-02-thumb.png";

  const customerNotice18 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/your-next-gen-digital-banking-experience-is-here-thumb.jpg"

  const customerNotice19 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/upgraded-versions-of-our-retail-and-corporate-banking-services-thumb.png"

  const customerNotice20 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/double-win-at-the-2025-financial-literacy-awards-thumb.png"

  const customerNotice21 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/decrease-in-the-bank-of-zambia-monetary-policy-rate-thumb.png"

  const customerNotice22 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-nxt-digital-banking-application-upgrade-thumb.png"

  const customerNotice23 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-Bids-LSMFEZ-ADVERT-11.12.24-banner.png"
  const customerNotice24 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-KYC-Notice-17-12-25-banner.png"
  const customerNotice25 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/1226_IZB_tax_noticve_thumbnail.png"
  const customerNotice26 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/1901_IZB_old_currency_thumbnail.png"
  const customerNotice27 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Notice_post_settlement_thumbnail.jpg"
  const customerNotice28 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-Notice-post-settlement-thumbnail.png"


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb Heading=" Notice / Announcements" img={BackgroundBrundcrumb} />
      {/* This Section has Renamed from Our Stories to Notice / Announcements */}
      <section>
        <div className="container notice-announcements-container">
          <div className="row">
            <div className="container">
              <div className="heading py-3">
                <h2 className="text-center pt-4 pb-4">Notice / Announcements</h2>
                {/* <p className="text-center">All News And Updates</p> */}
              </div>
            </div>
            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/MPR_notice_feb.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice28} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title">

                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/MPR_notice_feb.jpg" target="_blank">
                      MONETARY POLICY RATE (MPR)...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>February 14, 2026</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    We wish to notify our esteemed Customers that during the 9th - 10th February, 2026 Monetary Policy Committee Meeting, the Bank of Zambia has reduced the Monetary Policy Rate (MPR) from 14.25% to 13.5% ...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/MPR_notice_feb.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Notice_post_settlement.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice27} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title">

                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Notice_post_settlement.jpg" target="_blank">
                      SETTLEMENT OF DOMESTIC TRANSACTIONS...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>January 24, 2026</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    We wish to inform our Esteemed Customers that the Bank of Zambia Currency Directives, 2025, came into effect on 26th December, 2025. The Directives require mandatory use of Zambian Kwacha for all domestic transactions...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_Notice_post_settlement.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1901_IZB_old_currency.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice26} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title">

                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1901_IZB_old_currency.jpg" target="_blank">
                      END OF OLD CURRENCY EXCHANGE PERIOD
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>January 22, 2026</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Dear Valued Customer, kindly be advised that the old currency exchange period will end on March 31, 2026, in accordance with the Bank of Zambia Public Notice on the Withdrawal and Exchange of Currency...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1901_IZB_old_currency.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1226_IZB_tax_noticve-01.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice25} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title">

                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1226_IZB_tax_noticve-01.jpg" target="_blank">
                      RENEWAL OF TAX CLEARANCE CERTIFICATE...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>January 22, 2026</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Dear Valued Customer, we wish to remind you that all cross-border payments, including Swift and card transactions, that exceed USD2,000.00 or equivalent requires customers to have a valid Tax Clearance Certificate (TCC)...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1226_IZB_tax_noticve-01.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-KYC-Notice-17-12-25.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice24} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title">

                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-KYC-Notice-17-12-25.jpg" target="_blank">
                      UPDATION OF YOUR KYC DETAILS
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>December 17, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    We are carrying out mandatory KYC update on all customer accounts. Kindly visit your nearest branch to update your KYC to prevent disruption of continued service. If already done, please ignore this...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-KYC-Notice-17-12-25.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-Bids-LSMFEZ-ADVERT-11.12.24.pdf" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice23} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title">

                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-Bids-LSMFEZ-ADVERT-11.12.24.pdf" target="_blank">
                      INVITATION TO TENDER FOR THE CONSTRUCTION AND...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>December 15, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank (IZB) intends to undertake the Construction and Fitout works of its proposed Lusaka South Multi-Facility Economic Zone (LSMFEZ) branch and hereby invites sealed bids from eligible...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-Bids-LSMFEZ-ADVERT-11.12.24.pdf" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-nxt-digital-banking-application-upgrade-banner.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice22} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title">

                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-nxt-digital-banking-application-upgrade-banner.jpg" target="_blank">
                      IZB NXT DIGITAL BANKING APPLICATION UPGRADE
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>December 01, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Thank you for onboarding onto the IZB NXT App. As we now enter the    festive season of giving, we are delighted to give you new features on your IZB NXT App. To experience the new NXT level features...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-nxt-digital-banking-application-upgrade-banner.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/decrease-in-the-bank-of-zambia-monetary-policy-rate-banner.jpeg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice21} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/decrease-in-the-bank-of-zambia-monetary-policy-rate-banner.jpeg" target="_blank">
                      DECREASE IN THE BANK OF ZAMBIA MONETARY POLICY...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>November 18, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    We wish to notify our esteemed Customers that during the 10th - 11th November, 2025 Monetary Policy Committee Meeting, the Bank of Zambia has reduced the Monetary Policy Rate (MPR) from 14.5% to 14.25%.
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/decrease-in-the-bank-of-zambia-monetary-policy-rate-banner.jpeg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/double-win-at-the-2025-financial-literacy-awards-banner.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice20} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/double-win-at-the-2025-financial-literacy-awards-banner.jpg" target="_blank">
                      DOUBLE WIN AT THE 2025 FINANCIAL LITERACY AWARDS
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>November 07, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank is honoured to have received the Governor’s Award – First Prize in the following: Exceptional Campaign 2024 World Savings Day. Exceptional Campaign 2025 Financial Literacy
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/double-win-at-the-2025-financial-literacy-awards-banner.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/upgraded-versions-of-our-retail-and-corporate-banking-services-banner.png" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice19} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/upgraded-versions-of-our-retail-and-corporate-banking-services-banner.png" target="_blank">
                      UPGRADED VERSIONS OF OUR RETAIL AND...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>November 05, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank has successfully conducted a planned System Upgrade, and we are pleased to advise that the upgraded versions of the Retail and Corporate Banking Services are now operational.
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/upgraded-versions-of-our-retail-and-corporate-banking-services-banner.png" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/your-next-gen-digital-banking-experience-is-here.pdf" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice18} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/your-next-gen-digital-banking-experience-is-here.pdf" target="_blank">
                      Your Next-Gen Digital Banking Experience is Here!
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>October 20, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank presents IZB NXT – the Next-Gen Digital Banking App. This digital transformation brings you. A sleek, user-friendly interface for intuitive navigation. Smarter, faster banking capabilities to manage your money instantly...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/your-next-gen-digital-banking-experience-is-here.pdf" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1106_ property_Letter_v1_Artboard-02-banner.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice17} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1106_ property_Letter_v1_Artboard-02-banner.jpg" target="_blank">
                      PROPERTIES FOR SALE <br />
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>September 08, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    INDO ZAMBIA BANK LIMITED as mortgagees in possession is inviting bids from interested parties for purchase of the following properties on “as is where is basis.” Interested parties may purchase the bidding...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1106_ property_Letter_v1_Artboard-02-banner.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-for-bids-fitout-works-of-proposed-mazabuka-branch.pdf" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice16} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-for-bids-fitout-works-of-proposed-mazabuka-branch.pdf" target="_blank">
                      INVITATION FOR BIDS FITOUT WORKS OF PROPOSED...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>August 28, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank (IZB) intends to undertake fitout works of proposed Mazabuka branch and hereby invites separate sealed technical and financial bids from eligible contractors registered with National Council...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-for-bids-fitout-works-of-proposed-mazabuka-branch.pdf" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-for-proposals-for-consulting-services-job-evaluation-of-the-izb.pdf" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice15} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>

                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-for-proposals-for-consulting-services-job-evaluation-of-the-izb.pdf" target="_blank">
                      INVITATION FOR PROPOSALS FOR CONSULTING SERVICES...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>August 18, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank (IZB) intends to undertake the job evaluation consultancy and hereby invites sealed proposals from eligible consultants. The Bank now invites proposals to provide the consulting services...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-for-proposals-for-consulting-services-job-evaluation-of-the-izb.pdf" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/latest-tariffs-and-charges">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice14} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="/latest-tariffs-and-charges">
                      Latest Tariffs and Charges <br />
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>July 26, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Stay informed with IZB's latest tariffs and charges. Access comprehensive fee structures for personal and business banking services, loans, digital banking, and other transactions to help you make informed financial decisions.
                  </p>
                  <a href="/latest-tariffs-and-charges">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-at-top-of-the-game-in-chingola-banner.png" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice13} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-at-top-of-the-game-in-chingola-banner.png" target="_blank">
                      Indo Zambia Bank at Top of the Game in Chingola!
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>July 22, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    We are proud to have been recognised by Chingola Chamber of commerce as the top financial institution providing financial support to SMEs in Chingola.
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-at-top-of-the-game-in-chingola-banner.png" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-clinches-another-hat-trick-of-top-honours-banner.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice12} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-clinches-another-hat-trick-of-top-honours-banner.jpg" target="_blank">
                      Indo Zambia Bank Clinches another Hat-trick of Top...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>July 15, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank Clinches another Hat-trick of Top Honours. At the Liquid Intelligence Technologies Customer Excellence Awards 2025 we are proud to have won a hatrick of awards.
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-clinches-another-hat-trick-of-top-honours-banner.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-clinches-hat-trick-of-provincial-exhibition-awards-banner.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice11} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-clinches-hat-trick-of-provincial-exhibition-awards-banner.jpg" target="_blank">
                      Indo Zambia Bank Clinches Hat-trick of Provincial...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>July 15, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    We are proud to announce that Indo Zambia Bank emerged as the 1st place winner in the Best Bank Exhibition category at the following events.
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-clinches-hat-trick-of-provincial-exhibition-awards-banner.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0703_IZB_forex table revision.pdf" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice10} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0703_IZB_forex table revision.pdf" target="_blank">
                      REVISION OF ZMW AND FOREX FIXED DEPOSIT CARD...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>July 07, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank is pleased to announce revised card rates for both ZMW and Forex Fixed Deposits. Explore our competitive new rates designed to help you achieve your financial goals.
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0703_IZB_forex table revision.pdf" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_dormat_acount_reactivation_campaign-banner.png" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice9} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_dormat_acount_reactivation_campaign-banner.png" target="_blank">
                      Indo Zambia Bank has launched a Dormant ...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>June 27, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    We are pleased to inform you that Indo Zambia Bank has launched a Dormant Account Reactivation Campaign, which will run from 16th June 2025 to 30th June 2025. As part of this campaign...
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_dormat_acount_reactivation_campaign-banner.png" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/CUSTOMER-ENTITLEMENTS-AND-RESPONSIBILITIES-Pdf.pdf" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice8} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/CUSTOMER-ENTITLEMENTS-AND-RESPONSIBILITIES-Pdf.pdf" target="_blank">
                      CUSTOMER ENTITLEMENTS AND RESPONSIBILITIES
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>May 29, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    As an existing or potential customer, you can expect the following reasonable conduct from your bank as more fully outlined and detailed in the body of the Code. While we are committed...
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/CUSTOMER-ENTITLEMENTS-AND-RESPONSIBILITIES-Pdf.pdf" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/Unwarranted-Charges-And-Fees-Pdf.pdf" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice7} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/Unwarranted-Charges-And-Fees-Pdf.pdf" target="_blank">
                      Unwarranted Charges and Fees
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>May 29, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    The following charges and fees are deemed to be unwarranted and are hereby prohibited...
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/Unwarranted-Charges-And-Fees-Pdf.pdf" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0519_%20izb-property-Letter.pdf" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice6} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0519_%20izb-property-Letter.pdf" target="_blank">
                      Invitation to bids for Properties on sale
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>May 19, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    INDO ZAMBIA BANK LIMITED as mortgagees in possession is inviting bids from interested parties for purchase of the following properties on “as is where is basis.” Interested parties...
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/0519_%20izb-property-Letter.pdf" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-to-tender-for-the-furbishment-and-fitout-works-of-proposed-izb-branches-banner.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice4} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-to-tender-for-the-furbishment-and-fitout-works-of-proposed-izb-branches-banner.jpg" target="_blank">
                      INVITATION TO TENDER FOR THE FURBISHMENT AND...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>April 18, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank (IZB) intends to undertake the furbishment and fitout works of selected branches and hereby invites sealed bids from eligible contractors registered with National Council for Construction...
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/invitation-to-tender-for-the-furbishment-and-fitout-works-of-proposed-izb-branches-banner.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-invites-bids-for-the-sale-of-the-following-vehicles.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice3} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-invites-bids-for-the-sale-of-the-following-vehicles.jpg" target="_blank">
                      SALE OF MOTOR VEHICLES BY TENDER
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>April 18, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    INDO ZAMBIA BANK LTD INVITES BIDS FOR THE SALE OF THE FOLLOWING VEHICLES. The said vehicles will be sold on "as is" basis and can be inspected at Plot 1213/1214 Corner Great...
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-invites-bids-for-the-sale-of-the-following-vehicles.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/Zambia_All_A2-Poster_Heritage_new.pdf" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice5} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/Zambia_All_A2-Poster_Heritage_new.pdf" target="_blank">
                      Get to know your new Kwacha Notes
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>March 27, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    The new series of Zambian Kwacha, featuring six banknotes in K10, K20, K50, K100, K200, and K500 denominations, represents Zambia’s key economic pillars and cultural diversity, fostering a sense of connection...
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/Zambia_All_A2-Poster_Heritage_new.pdf" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1114_Customer notice.jpg" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice1} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/Customer_Notice_1.png" target="_blank">
                      CUSTOMER NOTICE: PHASING OUT OF CHEQUES
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>Feb 17, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem" }}>
                    As per the Bank of Zambia Public Notice, cheques will no longer be accepted as a payment instruction from 24th June 2026. Please take note of the following important dates...
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/Customer_Notice_1.png" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>

              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/27-11-izb%20notice%20tender%20pot.pdf">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={customerNotice} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1114_Customer notice.jpg" target="_blank" style={{ fontSize: "20px" }}>
                      CUSTOMER NOTICE -
                      Monetary Policy Rate (MPR) Update </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>Feb 15, 2025</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    We wish to notify our esteemed customers that the Bank of Zambia has increased the Monetary Policy Rate (MPR) from 14% to 14.5% during the 11th-12th Feb, 2025 Monetary Policy Committee Meeting.
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/1114_Customer notice.jpg" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>







              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/27-11-izb%20notice%20tender%20pot.pdf">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={career} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/EMPLOYMENT%20AND%20CAREER%20DEVELOPMENT%20OPPORTUNITIES.pdf" target="_blank" style={{ fontSize: "20px" }}>
                      EMPLOYMENT AND CAREER DEVELOPMENT OPPORTUNITIES </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>Feb 12, 2025</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank Limited, a bank that has been operating in Zambia since 1984 and has a branch network of 40 branches and agencies across the country, has exciting career opportunities...
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/EMPLOYMENT%20AND%20CAREER%20DEVELOPMENT%20OPPORTUNITIES.pdf" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>







              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/27-11-izb%20notice%20tender%20pot.pdf">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izb2025} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB 2025k Letter v2 crl.pdf" style={{ fontSize: "20px" }}>
                      Registration Of Vendors/Suppliers 2025    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>Jan 27, 2025</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank is in the process of registering new suppliers for the provision of goods and services to the Bank for the year 2025. Applications are therefore being invited from credible and established reputable...
                  </p>
                  <br />
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB 2025k Letter v2 crl.pdf">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>







              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/27-11-izb%20notice%20tender%20pot.pdf">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={solarTender} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/27-11-izb%20notice%20tender%20pot.pdf" style={{ fontSize: "20px" }}>
                      Tender Invitation for the Supply and Installation of Solar Hybrid...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>Nov 27, 2024</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank invites sealed proposals from eligible prospective Bidders for Supply and Installation of Solar Hybrid Inventor and Battery Storage Systems at the following locations.
                  </p>
                  <br />
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/27-11-izb%20notice%20tender%20pot.pdf">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/Jobs%20October%202024.pdf">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={job} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/Jobs%20October%202024.pdf" style={{ fontSize: "20px" }}>
                      CAREER OPPORTUNITIES FOR INDIVIDUALS AT INDO...<br />
                    </a>
                    <span style={{ fontSize: "15px", color: "gray" }}>Oct 15, 2024</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank Limited, a Commercial Bank which has been operating in Zambia since 1984 and has a branch network of 40 branches across the country, the Bank has exciting career opportunities for individuals...
                  </p>
                  <br />
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/Jobs%20October%202024.pdf">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>







              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/ADDENDUM%201-%20RFP.pdf">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={addendum} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/ADDENDUM%201-%20RFP.pdf" style={{ fontSize: "20px" }}>
                      ADDENDUM 1 FOR SOLAR CONSULTANCY TENDER
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>Aug 31, 2024</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Consultants are advised to take note of the responses to queries raised for the aforementioned tender for consultancy services to undertake load analysis, design, supervision and commissioning of solar system for IZB
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/ADDENDUM%201-%20RFP.pdf">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>







              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/RFP.pdf">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={rfp} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/RFP.pdf" style={{ fontSize: "20px" }}>
                      CANCELLED: REQUEST FOR PROPOSAL FOR THE...

                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>Aug 31, 2024</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Cancelled: Indo Zambia Bank invites sealed proposals from eligible prospective Consultants for the implementation of the payment Card Industry Data Security Standard (PCI DSS)
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/RFP.pdf">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>


              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/REQUEST FOR PROPOSAL FOR THE IMPLEMENTATION OF PAYMENT CARD INDUSTRIAL DATA SECURITY STANDARD AT IN.pdf">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={arrowwreport4} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/REQUEST FOR PROPOSAL FOR THE IMPLEMENTATION OF PAYMENT CARD INDUSTRIAL DATA SECURITY STANDARD AT IN.pdf" style={{ fontSize: "20px" }}>
                      Request For Proposal for The Implementation Of payment...
                      <br />
                    </a>
                    <span style={{ fontSize: "15px", color: "gray" }}>Aug 16, 2024</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank invites sealed proposals from eligible prospective Consultants for the implementation of the payment Card Industry Data Security Standard (PCI DSS)
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/REQUEST FOR PROPOSAL FOR THE IMPLEMENTATION OF PAYMENT CARD INDUSTRIAL DATA SECURITY STANDARD AT IN.pdf">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>







              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/REQUEST FOR PROPOSAL- CONSULTANCY FOR THE PROVISION OF DESIGN AND SUPERVISION OF A SOLAR HYBRID INV.pdf">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={arrowwreport3} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/REQUEST FOR PROPOSAL- CONSULTANCY FOR THE PROVISION OF DESIGN AND SUPERVISION OF A SOLAR HYBRID INV.pdf" style={{ fontSize: "20px" }}>
                      Request For Proposal- Consultancy For The Provision...
                      <br />
                    </a>
                    <span style={{ fontSize: "15px", color: "gray" }}>Aug 16, 2024</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank intends to install Solar Hybrid Inverters with Battery storage across its Branch and Automatic Teller Machines (ATMs) network Countrywide...
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/REQUEST FOR PROPOSAL- CONSULTANCY FOR THE PROVISION OF DESIGN AND SUPERVISION OF A SOLAR HYBRID INV.pdf">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>







              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/TenderInvitations">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={arrowwreport2} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>



                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/vendor.pdf" style={{ fontSize: "20px" }}>
                      Tender Invitation For Recruitment & Management Of Agents...
                      <br />
                    </a>
                    <span style={{ fontSize: "15px", color: "gray" }}>July 24, 2024</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank Limited has set aside funds to outsource the management of agents and targeted acquisition of customers...
                  </p>
                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/vendor.pdf">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>







              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/Invitationn">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={solar} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/REVISED SOLICITATION DOCUMENT- TENDER FOR THE DESIGN INSTALLATION AND COMMISSION OF SOLAR SYSTEM SOLUT.pdf" style={{ fontSize: "20px" }}>
                      Tender For Solar Hybrid Inverter And Battery System Across IZB...

                    </a>
                    <span style={{ fontSize: "15px", color: "gray" }}>July 15, 2024</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank has set aside funds for the procurement of a Solar System Solution across its Branch network...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/REVISED SOLICITATION DOCUMENT- TENDER FOR THE DESIGN INSTALLATION AND COMMISSION OF SOLAR SYSTEM SOLUT.pdf">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/AnnualReport">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={arrowwreport} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/2023-annual report.pdf" style={{ fontSize: "20px" }}>
                      Indo Zambia Bank Annual Report - Dec 2023

                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>June 01, 2024</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Dear Esteemed Stakeholders, it is with great pleasure that we present to you Indo Zambia Bank’s Annual Report...
                  </p>

                  <a href="https://izbassetsmain.blob.core.windows.net/izbwebassets/2023-annual report.pdf">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/AAcreditratings">
                  <div className="img-holder">
                    <div className="inner">
                      <img src={aarating} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a>Indo Zambia Bank Achieves AA Credit Rating!
                      <br /></a>
                    <span style={{ fontSize: "15px", color: "gray" }}>May 16, 2024</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    We are thrilled to announce that Indo Zambia Bank has been awarded the prestigious AA credit rating by Premier Credit Rating Agency...
                  </p>
                  <Link
                    to="/AAcreditratings">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" /></h5></Link>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />

                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/Monetarypoliceratenovember">
                  <div className="img-holder">
                    <div className="inner">
                      <img src={storie11} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-4">

                    <a>CUSTOMER NOTICE<br />Monetary Policy Rate (MPR)<br /></a>

                    <span style={{ fontSize: "15px", color: "gray" }}>November 27, 2023</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    We wish to notify our esteemed Customers that the Bank of Zambia during
                    the 20th 21st November, 2023 MPC Quaterly Meeting, increased the
                    Monetary Policy ...
                  </p>
                  <Link
                    to="/Monetarypoliceratenovember">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" /></h5></Link>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />

                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/Workerscopensation">
                  <div className="img-holder">
                    <div className="inner">
                      <img src={storie21} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-4">

                    <a>IZB - Workers Compensation Fund Control Board Zambia...</a><br />

                    <span style={{ fontSize: "15px", color: "gray" }}>October 20, 2023</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    Indo Zambia Bank is proud to announce the launch of the provision of the E-Workers on our INDO Internet Banking platform .This Indo NXT Corporate Banking platform ...
                  </p><br />
                  <Link
                    to="/Workerscopensation">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" /></h5></Link>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />

                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/Monetarypolicerate">
                  <div className="img-holder">
                    <div className="inner">
                      <img src={storie1} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    {/* <a>MONETARY POLICY RATE</a><br/> */}
                    <a>Monetary Policy Rate</a><br /><br />

                    <span style={{ fontSize: "15px", color: "gray" }}>Aug 28, 2023</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    We wish to notify our esteemed customers that the Bank of Zambia increased the Monetary Policy Rate (MPR) from 9.50% to 10%...
                  </p><br />
                  <Link
                    to="/Monetarypolicerate">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" /></h5></Link>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                  <br /><br />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/Indopremierbanking">
                  <div className="img-holder">
                    <div className="inner">
                      <img src={storie5} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a>Introducing Indo Premier Banking Suite - Tailored To...</a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>July 15, 2023</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    We cordially invite you to the Indo Premier Banking Suite.
                    At Indo Zambia Bank (IZB), we understand and appreciate that you, our valued customers ...
                  </p><br />
                  <Link
                    to="/Indopremierbanking">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" /></h5></Link>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />

                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/Officiallaunchofizbhq">
                  <div className="img-holder">
                    <div className="inner">
                      <img src={storie2} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-4">
                    <a>The Official Launch Of The New Indo House Corporate...</a><br />




                    <span style={{ fontSize: "15px", color: "gray" }}>July 6, 2023</span>
                  </h3>
                  <p className="" style={{ marginBottom: "0rem" }}>
                    The Board, Management and Staff of the Indo Zambia Bank wish to extend their sincere gratitude to the President of the Republic of Zambia ...
                  </p>
                  <Link
                    to="/Officiallaunchofizbhq">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right" }}>Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" /></h5></Link>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>


      <AllAcountsSection />
    </>
  );
};

export default Stories;
